export function createHomePage(): string {
  return `
    <div>
    <h1>Ubiquity TypeScript Template Home</h1>
    </div>
  `;
}
